import React from 'react';
import './App.css';

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages';
import Shop from './pages/shop';
import FlyFishing from './pages/flyfishing';
import ItemDetail from './pages/shop/item_detail';
import Cart from './pages/cart';
import CheckoutSuccess from './pages/checkout/success';
import { CartProvider } from './context/CartContext';

function App() {
  return (
    <Router>
      <CartProvider>
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/shop' element={<Shop />} />
          <Route path='/shop/detail/:id' element={<ItemDetail />} />
          <Route path='/flyfishing' element={<FlyFishing />} />
          <Route path='/cart' element={<Cart />} />
          <Route path='/checkout/success' element={<CheckoutSuccess />} />
        </Routes>
      </CartProvider>
    </Router>
  );
}

export default App;
